import { Button, Modal, Spin } from 'antd';

import type { SelectTypeBotModalType } from '@app/components/Modals/SelectTypeBotModal/types';
import { CANCEL } from '@app/constants';
import { useForceCloseModal } from '@app/providers/CheckNetworkProvider/CheckNetworkProvider';

import '@app/components/Modals/SelectTypeBotModal/styles/SelectTypeBotModal.desktop.scss';
import { BOT_TYPE_STYLES } from '../BotDetailsModal/constants';
import { DEFAULT_BOT_TYPE_STYLE } from '../BotDetailsModal/constants/botColors';

export const SelectTypeBotModal: SelectTypeBotModalType = ({
  isOpen,
  onCancel,
  onSelect,
  list,
  isLoading = false,
  isButtonsLoading = false,
}) => {
  useForceCloseModal(onCancel, isOpen);
  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      title="Добавить робота"
      cancelText={CANCEL}
      classNames={{
        body: 'select-type-bot-modal-body',
        header: 'select-type-bot-modal-header',
      }}
      okButtonProps={{ loading: isLoading }}
      cancelButtonProps={{ disabled: isLoading }}
      footer={<Button onClick={onCancel}>{CANCEL}</Button>}
    >
      {isLoading ? (
        <Spin spinning />
      ) : (
        list.map(({ id, title }) => (
          <Button
            key={id}
            type="primary"
            block
            className={BOT_TYPE_STYLES[id] || DEFAULT_BOT_TYPE_STYLE}
            style={{ marginBottom: '10px' }}
            onClick={() => onSelect({ id, title })}
            loading={isButtonsLoading}
          >
            {title}
          </Button>
        ))
      )}
    </Modal>
  );
};
